export const getJackpot = ({ amount, step, currency, hitTime = null }) => ({
    currencyCode: currency,
    step: Number(step) || 0.01,
    amount: amount * 0.99,
    originAmount: amount,
    hitTime
});

export const parseJackpotsXML = (xmlDoc) => {
    const getAttributes = (node) => Object.fromEntries(
        Array.prototype.map.call(node?.attributes || [], ({ name, value }) => [name, value])
    );
    const getAmountList = (node) => {
        const amountNodeList = node?.querySelectorAll?.('amount') || [];

        return {
            amount: Array.prototype.map.call(amountNodeList, (amountNode) => ({
                ...getAttributes(amountNode),
                jackpotAmount: Number(amountNode.innerHTML || amountNode.textContent)
            }))
        };
    };

    const casinodataNode = xmlDoc.querySelector('casinodata');
    const gameDataNodeList = xmlDoc.querySelectorAll('gamedata');
    const casinodata = {
        ...getAttributes(casinodataNode),
        amountList: getAmountList(casinodataNode)
    };
    const gamedata = Array.prototype.map.call(gameDataNodeList, (gameDataNode) => {
        return {
            ...getAttributes(gameDataNode),
            amountList: getAmountList(gameDataNode)
        };
    });

    return {
        casinodata,
        gamedata
    };
};

export const parseCasinoJackpots = (gameData) => gameData.reduce((memo, {
        game,
        amountList = {}
    }) => {
        const {
            step,
            currency,
            jackpotAmount: amount,
            guaranteedHitTime: hitTime
        } = amountList.amount[0];

        return { ...memo, [game]: getJackpot({ amount, step, currency, hitTime }) };
    }, {});

export const parseVFJackpots = (vfJackpots = []) => vfJackpots.reduce((memo, {
        jackpotName: gameCode,
        jackpotAmount: amount,
        Step: step,
        currency: currency
    }) => ({ ...memo, [gameCode]: getJackpot({ amount, step, currency }) }), {});
